import { render, staticRenderFns } from "./CommentBoard.vue?vue&type=template&id=1c53b46e&scoped=true&"
import script from "./CommentBoard.vue?vue&type=script&lang=js&"
export * from "./CommentBoard.vue?vue&type=script&lang=js&"
import style0 from "./CommentBoard.vue?vue&type=style&index=0&id=1c53b46e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c53b46e",
  null
  
)

export default component.exports